/* eslint-disable @typescript-eslint/await-thenable */
import { Field, Form, Formik } from 'formik'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { AppLayout } from 'src/common/components/Layout/AppLayout'
import { useSendPWResetEmailMutation } from 'src/services/mainAPI'
import { wrapper } from 'src/store'
import { useAppSelector } from 'src/store/hooks'
import * as Yup from 'yup'

const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required')
})

const ForgotPassword = () => {
    const router = useRouter()
    const [sendPWResetEmail, { error, data }] = useSendPWResetEmailMutation()
    const user = useAppSelector((state) => state.user.data)

    useEffect(() => {
        if (user) {
            if (router.query?.redirect) {
                void router.replace(router.query?.redirect as string)
            } else {
                void router.replace('/dashboard-new')
            }
        }
    }, [user])

    return (
        <AppLayout pageTitle="Login">
            <div className="min-h-screen pr-0 md:pr-24 smMd:pt-28 relative">
                <img
                    alt="Login background image"
                    src="/login-bg.svg"
                    className="md:mt-0 md:absolute md:top-32 md:left-0 md:bottom-0 md:right-0 w-full "
                    style={{ zIndex: -1 }}
                />
                {/* Form section */}
                <Formik
                    enableReinitialize
                    validateOnMount={false}
                    initialValues={{
                        email: ''
                    }}
                    validateOnBlur
                    validationSchema={ForgotPasswordSchema}
                    onSubmit={async (values) => {
                        // console.log(JSON.stringify(values, null, 2))
                        await sendPWResetEmail(values.email)
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="bg-white smMd:shadow-sm smMd:rounded-lg smMd:max-w-xl mr-auto md:mr-0 smMd:ml-auto z-10 block">
                                <div className="p-8 smMd:p-16">
                                    <div className="grid grid-cols-1 gap-6">
                                        <h1 className="font-medium text-4xl">
                                            Forgot Password
                                        </h1>

                                        {data && data.newPassword.length > 1 ? (
                                            <div>
                                                <p className="font-light mb-4 text-yf-green">
                                                    An email has been sent to this account
                                                    with your new password
                                                </p>
                                                <a
                                                    className="text-yf-purple text-base font-normal cursor-pointer"
                                                    href="/login"
                                                >
                                                    Login
                                                </a>
                                            </div>
                                        ) : (
                                            <p className="font-light mb-4">
                                                Please enter your email below for a
                                                password-reset email.
                                            </p>
                                        )}

                                        {!data && (
                                            <>
                                                <Field name="email">
                                                    {({
                                                        field, // { name, value, onChange, onBlur }
                                                        meta
                                                    }) => (
                                                        <label className="block">
                                                            <input
                                                                disabled={isSubmitting}
                                                                autoComplete="username"
                                                                type="email"
                                                                placeholder="Email"
                                                                className="disabled:bg-gray-200 disabled:opacity-50 mt-1 block w-full rounded-md py-4 border-gray-300 focus:border-yf-green focus:ring-1 focus:ring-yf-green placeholder-gray-400"
                                                                {...field}
                                                            />
                                                            {meta.touched &&
                                                                meta.error && (
                                                                    <span className="text-red-500 text-sm">
                                                                        {meta.error}
                                                                    </span>
                                                                )}
                                                        </label>
                                                    )}
                                                </Field>

                                                {error && (
                                                    <div className="block">
                                                        <p className="text-red-500 font-medium">
                                                            {error}
                                                        </p>
                                                    </div>
                                                )}

                                                <div className="block text-right">
                                                    <a
                                                        className="text-yf-purple text-base font-normal cursor-pointer"
                                                        href="/login"
                                                    >
                                                        Login
                                                    </a>
                                                </div>

                                                <div className="flex flex-col text-center mb-4">
                                                    <button
                                                        type="submit"
                                                        disabled={isSubmitting}
                                                        className="mb-3 py-5 bg-yf-green text-white font-medium rounded-lg focus:outline-none focus:ring-2 ring-yf-green-400"
                                                    >
                                                        {isSubmitting
                                                            ? 'Loading...'
                                                            : 'Submit'}
                                                    </button>

                                                    <div className="my-4" />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </AppLayout>
    )
}

ForgotPassword.getInitialProps = wrapper.getInitialPageProps(() => () => null)

export default ForgotPassword
